module.exports = __webpack_public_path__ + "static/IN-51043c133c8f59ea51f4f52592ed481a.svg";